module.exports = __webpack_public_path__ + "img/fl.7f51de80.png";